exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation ul {\n  list-style: none;\n  padding: 0;\n  margin-right: .5rem;\n  display: -ms-flexbox;\n  display: flex;\n}\n.navigation-item {\n  margin-right: .5rem;\n}\n.navigation-item a {\n  display: block;\n  line-height: 2;\n  color: #333;\n  text-decoration: none;\n  font-weight: 600;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  transition: all .2s ease-in-out;\n}\n.navigation-item a:hover {\n  color: #15a5bb;\n}\n.navigation-item a.is-active {\n  color: #07383f;\n}\n", ""]);

// exports
